
import React from 'react';
import Select from 'react-select';
import BaseApi from '../../api/BaseApi.js';
import ScreenCaption from '../screen-caption.js';
import details from '../../img/details.svg';
import add from '../../img/add.svg';
import sortasc from '../../img/sort-asc.svg';
import sortdesc from '../../img/sort-desc.svg';


export default class InstitutionsScreen extends React.Component {
    constructor(props) {
        super(props);
        var selectedRegionId = ""
        var sortField = null
        var sortOrder = null

        const args = props.args === undefined ? {} : props.args

        if (args.sortField !== undefined) {
            sortField = args.sortField
        }

        if (args.sortOrder !== undefined) {
            sortOrder = args.sortOrder
        }

        if (args.selectedRegionId !== undefined) {
            selectedRegionId = args.selectedRegionId
        }


        this.state = {
            args: args,
            regionOptions: [],
            selectedRegionId: selectedRegionId,
            nameCriteria: "",
            prevNameCriteria:"",
            institutions: [],
            sortField: sortField, 
            sortOrder: sortOrder 
        };

        this.nameSearch = this.nameSearch.bind(this);  
        this.regionChangeHandler = this.regionChangeHandler.bind(this);  
        this.nameCriteriaChangeHandler = this.nameCriteriaChangeHandler.bind(this);  
        this.sortClicked = this.sortClicked.bind(this)
    }

    async componentDidMount() {
        this.getRegionOptons()
        this.getDataWithCriteria()
        setTimeout(this.nameSearch, 2000);
       
    }
      
    getDataWithCriteria() {

        var parameters = {list: true}

        parameters.regionid = this.state.selectedRegionId

        if (this.state.nameCriteria.length > 0) {
            parameters.name = this.state.nameCriteria
        }

        if (this.state.sortField) {
            parameters.orderby = this.state.sortField
        }

        if (this.state.sortOrder) {
            parameters.sortorder = this.state.sortOrder
        }

        BaseApi.get("/institutions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: parameters, withCredentials: true})
        .then(res => {
            this.setState({institutions: res.data})
        })    
        .catch(error=>console.log(error))
        
    }

    getRegionOptons() {
        BaseApi.get("/regions", {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {list: true}, withCredentials: true})
        .then(res => {
            const regionOptions = res.data.map(({id, name}) => ({value: id, label: name}))
            regionOptions.push({value: "", label: "Все"})
            this.setState({regionOptions: regionOptions})
        })    
        .catch()
    }

    regionChangeHandler(selectedOption) {
        var args = this.state.args
        args.selectedRegionId = selectedOption.value
        this.setState({selectedRegionId: selectedOption.value, args: args}, this.getDataWithCriteria)
    }

    nameCriteriaChangeHandler(event) {
        this.setState({nameCriteria: event.target.value})
    }

    sortClicked(event) {
        var currentField = this.state.sortField
        var currentOrder = this.state.sortOrder
        switch (event.target.id) {
            case "regionCaption" :
                if (currentField === "region") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "region"
                    currentOrder = "asc"
                }
            break
            case "nameCaption" :
                if (currentField === "name") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "name"
                    currentOrder = "asc"
                }
            break 
            case "locationCaption" :
                if (currentField === "location") {
                    if (currentOrder !== "desc") {
                        currentOrder = "desc"
                    } else {
                        currentOrder = "asc"
                    }
                } else {
                    currentField = "location"
                    currentOrder = "asc"
                }
            break           
        }
        var args = this.state.args
        args.sortField = currentField
        args.sortOrder = currentOrder
        this.setState({sortField: currentField, sortOrder: currentOrder, args: args}, this.getDataWithCriteria)
    }


    nameSearch() {
        if (this.state.nameCriteria !== this.state.prevNameCriteria) {
            var args = this.state.args
            args.pageCount = 0
            this.setState({prevNameCriteria: this.state.nameCriteria, pageCount: 0, args: args}, this.getDataWithCriteria)
        }    
        setTimeout(this.nameSearch, 2000)
    }

    isFieldSortedDesc(field) {
        return this.state.sortField === field && this.state.sortOrder === "desc"
    }

    isFieldSortedAsc(field) {
        return this.state.sortField === field && this.state.sortOrder !== "desc"
    } 

    openInstitute(id) {
        this.props.navigate("institute", {caller: "institutes", callargs: this.state.args, institute: id})
    } 

    renderInstitution(value) {
        return (
            <tr
                key={value.id}
                className="table-row-clickable"
                onClick={() => this.openInstitute(value.id)}
            >
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {value.region}
                </td>
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {value.location}
                </td>
                <td style={{textAlign: 'left',  padding: '4px'}}>
                    {value.name}
                </td>
            </tr>
        )
    }

    render() {
        
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.state.args} caption={"Учреждения"}/>
                <div className="row mt-4 mb-3">
                    <div className="col-lg-5">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Фильтр</h6>
                                <div className="mb-3">
                                    <label for="name"> Наименование:</label>
                                    <input type="text" class="form-control" id="name" value={this.state.nameCriteria} onChange={this.nameCriteriaChangeHandler} />
                                </div>
                                <div className="mb-3">
                                    <label for="region">Регион:</label>
                                    <Select options= {this.state.regionOptions} 
                                            id="region" 
                                            onChange={this.regionChangeHandler}
                                            />
                                </div>            
                            </div>
                        </div>

                    </div>
                    <div className="col-lg-7 d-flex align-items-start justify-content-end mt-3 mt-lg-0">
                        <button
                            type="button"
                            className="btn btn-primary d-flex align-items-center"
                            onClick={() => this.openInstitute("")}
                        >
                            Добавить учреждение
                        </button>
                    </div>
                </div>

                <div className="card shadow-sm">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0 align-middle">
                                <thead className="table-primary">
                                    <tr>
                                        <th 
                                            id="regionCaption" 
                                            onClick={this.sortClicked}
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                        >
                                            Регион {" "}
                                            {this.isFieldSortedDesc("region") && <img src={sortdesc} height="16" width="16"/>}
                                            {this.isFieldSortedAsc("region") && <img src={sortasc} height="16" width="16"/>}
                                        </th> 
                                        <th 
                                            id="locationCaption"
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            onClick={this.sortClicked}>
                                            Город {" "}
                                            {this.isFieldSortedDesc("location") && <img src={sortdesc} height="16" width="16"/>}
                                            {this.isFieldSortedAsc("location") && <img src={sortasc} height="16" width="16"/>}
                                        </th> 
                                        <th id="nameCaption"
                                            style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}
                                            onClick={this.sortClicked}>
                                            Наименование
                                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                                        </th>                                         
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.institutions.map((value, index) => this.renderInstitution(value))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>    

                {/*    
                <div class="container mt-5">
                    <div class="row" style={{"height" : "50px"}}>  
                        <div class="col-3 border border-white" 
                            id="regionCaption" 
                            style={{"background-color" : "#0ee"}}
                            onClick={this.sortClicked}>
                            Регион
                            {this.isFieldSortedDesc("region") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("region") && <img src={sortasc} height="16" width="16"/>}
                        </div> 
                        <div class="col-3 border border-white" 
                            id="locationCaption"
                            style={{"background-color" : "#0ee"}}
                            onClick={this.sortClicked}>
                            Город
                            {this.isFieldSortedDesc("location") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("location") && <img src={sortasc} height="16" width="16"/>}
                        </div> 
                        <div class="col-4 border border-white" 
                            id="nameCaption"
                            style={{"background-color" : "#0ee"}}
                            onClick={this.sortClicked}>
                            Наименование
                            {this.isFieldSortedDesc("name") && <img src={sortdesc} height="16" width="16"/>}
                            {this.isFieldSortedAsc("name") && <img src={sortasc} height="16" width="16"/>}
                        </div> 
                        <div class="col-1 border border-white" style={{"background-color" : "#0ee"}} onClick={()=>this.openInstitute(null)}>
                            <img src={add} height="16" width="16"/>
                        </div> 
                    </div>        
                    {this.state.institutions.map((value, index) => this.renderInstitution(value))}
                </div>
                */}
            </div> 
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/institutions.js